import React, { Suspense, useEffect } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { LoggedInMobileGate } from './LoggedInMobileGate';
import { LoggedInMobileResultsPage } from './LoggedInMobileResultsPage';
import { LoggedInMobileUpgradePaywall } from './LoggedInMobileUpgradePaywall';
import { SelectSiteRoute } from './SelectSiteRoute';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { ConnectDomainRoute } from './ConnectDomainRoute';
import { ConnectIntroRoute } from './ConnectIntroRoute';
import { ConnectEntriRoute } from './ConnectEntriRoute';
import { ConnectErrorRoute } from './ConnectErrorRoute';
import { ConnectSuccessRoute } from './ConnectSuccessRoute';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { ExperimentSpecs } from '../../constants';
const LoggedInSplitPage = /*#__PURE__*/React.lazy(() => import('./LoggedInSplitPage').then(m => ({
  default: m.LoggedInSplitPage
})));
const ScrollToTopOnNavigate = () => {
  const _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
export const LoggedInMobileGatePages = _ref => {
  var _getPremiumEssentials;
  let handlers = _ref.handlers,
    onSelectSite = _ref.onSelectSite,
    onSplitPageContinue = _ref.onSplitPageContinue,
    onSplitPageBack = _ref.onSplitPageBack,
    onConnectEntri = _ref.onConnectEntri,
    onConnectIntro = _ref.onConnectIntro,
    onConnectManual = _ref.onConnectManual,
    onUpgradeContinue = _ref.onUpgradeContinue,
    onManualConnectSuccess = _ref.onManualConnectSuccess,
    onConnectEntriBack = _ref.onConnectEntriBack,
    onConnectIntroBack = _ref.onConnectIntroBack,
    onConnectErrorReturnToResults = _ref.onConnectErrorReturnToResults,
    onConnectError = _ref.onConnectError,
    externalViewer = _ref.externalViewer;
  const loggedInMobileConnectEnabled = (_getPremiumEssentials = getPremiumEssentialsSafe()) == null || (_getPremiumEssentials = _getPremiumEssentials.experiments) == null ? void 0 : _getPremiumEssentials[ExperimentSpecs.LoggedInMobileConnect];
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, /*#__PURE__*/React.createElement(DomainSearchGateModule.SDK.Components.ModalsProvider, null, /*#__PURE__*/React.createElement(ScrollToTopOnNavigate, null), /*#__PURE__*/React.createElement(Switch, null, loggedInMobileConnectEnabled && /*#__PURE__*/React.createElement(Route, {
    path: "/connect-manually",
    render: () => /*#__PURE__*/React.createElement(ConnectDomainRoute, {
      onManualConnectSuccess: onManualConnectSuccess
    })
  }), loggedInMobileConnectEnabled && /*#__PURE__*/React.createElement(Route, {
    path: "/connect-entri",
    render: () => /*#__PURE__*/React.createElement(ConnectEntriRoute, {
      onBack: onConnectEntriBack,
      onConnectEntri: onConnectEntri,
      handlers: handlers,
      externalViewer: externalViewer
    })
  }), loggedInMobileConnectEnabled && /*#__PURE__*/React.createElement(Route, {
    path: "/connect-success",
    render: () => /*#__PURE__*/React.createElement(ConnectSuccessRoute, null)
  }), loggedInMobileConnectEnabled && /*#__PURE__*/React.createElement(Route, {
    path: "/connect-error",
    render: () => /*#__PURE__*/React.createElement(ConnectErrorRoute, {
      onReturnToResults: onConnectErrorReturnToResults
    })
  }), loggedInMobileConnectEnabled && /*#__PURE__*/React.createElement(Route, {
    path: "/connect-intro",
    render: () => /*#__PURE__*/React.createElement(ConnectIntroRoute, {
      onConnectEntri: onConnectEntri,
      onConnectManual: onConnectManual,
      onBack: onConnectIntroBack
    })
  }), loggedInMobileConnectEnabled && /*#__PURE__*/React.createElement(Route, {
    path: "/upgrade-paywall",
    render: () => /*#__PURE__*/React.createElement(LoggedInMobileUpgradePaywall, {
      onUpgradeContinue: onUpgradeContinue
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/select-site",
    render: () => /*#__PURE__*/React.createElement(SelectSiteRoute, {
      onSelectSite: onSelectSite,
      handlers: handlers,
      externalViewer: externalViewer,
      onConnectError: onConnectError,
      onConnectIntro: onConnectIntro,
      onConnectManual: onConnectManual
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/split-page",
    render: () => /*#__PURE__*/React.createElement(LoggedInSplitPage, {
      onContinue: onSplitPageContinue,
      onBack: onSplitPageBack
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/results",
    render: () => /*#__PURE__*/React.createElement(LoggedInMobileResultsPage, {
      handlers: handlers,
      externalViewer: externalViewer,
      onConnectIntro: onConnectIntro,
      onConnectManual: onConnectManual,
      onConnectError: onConnectError
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/",
    render: () => /*#__PURE__*/React.createElement(LoggedInMobileGate, {
      handlers: handlers
    })
  }))));
};
//# sourceMappingURL=LoggedInMobileGatePages.js.map